module.exports = __webpack_public_path__ + "img/Bilde5.7cb1fc4b.jpg";